module.exports = __webpack_public_path__ + "static/media/pes2020.cbddf858.jpg";